import { Controller } from "@hotwired/stimulus"

// Auto-saves the "Alertarme si baja de $X" threshold input on change, so
// there's no separate save button (matches the mockup).
export default class extends Controller {
  save() {
    this.element.requestSubmit()
  }
}
